import { render, staticRenderFns } from "./notificacion.vue?vue&type=template&id=c8688100&scoped=true"
import script from "./notificacion.vue?vue&type=script&lang=js"
export * from "./notificacion.vue?vue&type=script&lang=js"
import style0 from "./notificacion.vue?vue&type=style&index=0&id=c8688100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8688100",
  null
  
)

export default component.exports